export default __webpack_public_path__ + "static/media/hero.7ed12910.svg";